const buttonCls = "_61brh6u5k";
const notificationBadge = "_61n104mn2e";
const userAreaWrapperCls = "_61u9qwrox";
const backdropCls = "_61bj2g5as";

export { backdropCls, buttonCls, notificationBadge, userAreaWrapperCls };
import "./tool.user-area.style.linaria.module.css";
//# sourceMappingURL=tool.user-area.style.js.map
